const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const base_url = isLocalhost 
  ? "http://127.0.0.1:55555/api/v1" 
  : window.location.origin + "/api/v1";

export default base_url;
